
import styles from "./Footer.module.css"

const Footer = () => {
    return (
        <footer className={styles.footer}>
            <div className={styles.footerContent}>
                <a href="https://www.tonton.com.my/pages/termofuse.html" target="_blank">Terms & Condition</a>
                <a href="https://www.tonton.com.my/pages/howitworks.html" target="_blank">FAQ</a>
                <a href="https://www.tonton.com.my/pages/aboutus.html" target="_blank">About Us</a>
                <a href="https://www.tonton.com.my/pages/privacy.html" target="_blank">Legal</a>
                <a href="https://www.tonton.com.my/pages/contactus.html" target="_blank">Contact Us</a>
            </div>
        </footer>
    )
}

export default Footer;